import { LoginModal } from '~/features/LoginModal';

export const Login = () => <LoginModal />;
